module.exports = __webpack_public_path__ + "img/md_flow03.ec1efe0a.png";